import { gql } from "gql";

export const SEND_POST_TO_MODERATION = gql(/* GraphQL */ `
  mutation SendPostToModeration($postId: ID!) {
    sendPostToModeration(postId: $postId) {
      ...PostCard
    }
  }
`);
